import messages from './messages';

export const EligibilityErrors = {
	b2b_partner_subscription_upsert_user_conflict: messages.alreadyRedeemed,
	b2b_partner_eligibility_redeem_invalid_partner: messages.missingId,
	b2b_partner_eligibility_redeem_invalid_id: messages.errorInvalidId,
	b2b_partner_group_code_not_found: messages.errorInvalidGroupCode,
} as const;

type EligibilityErrorKey = keyof typeof EligibilityErrors;

export const isEligibilityErrorKey = (value: string): value is EligibilityErrorKey =>
	value in EligibilityErrors;

export const EligibilityDescriptors = {
	accesscode: messages.accesscode,
	email: messages.email,
	employeeid: messages.employeeid,
	employeeemail: messages.employeeemail,
} as const;

export type EligibilityDescriptorKey = keyof typeof EligibilityDescriptors;

export const isEligibilityDescriptorKey = (value: string): value is EligibilityDescriptorKey =>
	value in EligibilityDescriptors;
